import React from "react";

import { getSS } from '../../helpers'

const MembershipConfirmation: React.FC = () => {

  let membership = getSS('membership')

  return (
    <>
      <div className="row">
        <div className="membership-confirmation clearfix box">
          <div className="medium-6 columns">
            <p>Thank you for deciding to become a member and helping to support our vital science and conservation work.</p>
            { membership.payment_type === 'Regular' &&
              <p>You've selected the <strong>{membership.selected_membership.title}</strong> package and chosen to pay <strong>£{(membership.selected_membership.base_price - membership.selected_membership.direct_debit_discount).toFixed(2)}</strong> per year by Direct Debit.</p>
            }
            { membership.payment_type === 'Single' &&
              <p>You've selected the <strong>{membership.selected_membership.title}</strong> package and chosen to pay <strong>£{(membership.selected_membership.base_price).toFixed(2)}</strong> by Card or PayPal.</p>
            }
          </div>
          <div className="medium-6 columns">
            <div className="membership-type">
              <p className="type">{membership.selected_membership.title} membership</p>
              <p>{membership.renewal_donation_added ? membership.selected_membership.plus_description : membership.selected_membership.description}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MembershipConfirmation;